export const configAhs = {
  originatingSite: 'appliance-portal-production',
  referrer: 'appliance.ahs.com',
  chatDurationInMinutes: 10080,
  styles: {
    iconType: 'CHAT',
    openChat: { color: '#ffffff', backgroundColor: '#182AF0' },
    closeChat: { color: '#ffffff', backgroundColor: '#182AF0' },
  },
  customStyles: (isMobile: boolean) => {
    return {
      global: {
        frameWidth: isMobile ? '100%' : '400px',
        frameHeight: isMobile ? '100%' : '600px',
      },
      footer: {
        footerBackgroundColor: '#FFFFFF',
        buttonFontSize: '16px',
        buttonBackgroundColor: '#FFFFFF',
      },
    }
  },
  supportedMessagingContentTypes: ['text/plain'],
  customizationObject: (icon: string) => {
    return {
      header: {
        dropdown: true,
      },
      footer: {
        disabled: false,
      },
      transcript: {
        displayIcons: true,
        iconSources: {
          agentMessage: localStorage.getItem(icon),
        },
        hideDisplayNames: true,
        messageFontSize: '16px',
      },
    }
  },
  iconSvg: `<svg id="logo" width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_2342_1912" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="26">
        <path d="M24 0.0540771H0V26H24V0.0540771Z" fill="white"/>
        </mask>
        <g mask="url(#mask0_2342_1912)">
        <path d="M7.9834 10.0333H23.9501V18.0167C23.9501 22.4227 20.3728 26.0001 15.9668 26.0001C11.5607 26.0001 7.9834 22.4227 7.9834 18.0167V10.0333Z" fill="#182AF0"/>
        <path d="M15.9667 18.0167H0V8.03745L7.98337 0.0540771L15.9667 8.03745V18.0167Z" fill="#F31A1A"/>
        <path d="M15.9668 10.0333H7.9834V18.0167H15.9668V10.0333Z" fill="#1D1363"/>
        <path d="M22.0421 25.2975V25.1139H22.8165V25.2975H22.5291V25.9282H22.3375V25.2975H22.0421ZM23.559 25.1139H23.8623V25.9282H23.6707V25.2975L23.4552 25.9282H23.2955L23.08 25.2975V25.9282H22.8884V25.1139H23.1917L23.3753 25.6807L23.559 25.1139Z" fill="#182AF0"/>
        </g>
        </svg>`,
}
